import React, { Suspense } from 'react'
import { Redirect, Route as BaseRoute } from 'react-router-dom'
import { observer } from '~/common/mobx.decorator'
import { authStore, routerStore } from '~/stores'
import { Error403 } from '~/components/errors'
import { Backdrop, CircularProgress, Zoom } from '@material-ui/core'
import { PATHS } from '~/common/constants'
import CareVerifyCredentialFeature from '~/features/care-verify-credential'
// import { commonSignInStore } from '~/features/common-signin/common-signin.store'

const RouteComponent = observer(({ auth, feature, component: Component, transition: Transition, ...props }) => {
	// !! This is a legacy code base
	// const { state } = useLocation()
	// const socialAuthenticationId = state?.workerSocialInfo?.socialAuthenticationId

	if (!Component) {
		return <Redirect to={PATHS.common.home} />
	}
	const pathsToRedirect = [
		PATHS.common.signin,
		PATHS.common.authorization,
		PATHS.common.reset,
		PATHS.common.link_account,
		PATHS.common.link_options,
		PATHS.common.signup,
	]
	const pathname = window.location.pathname

	// If the current path is sign in and the user do not complete the profile yet
	// just stay in the sign in page

	if (authStore.requiredCompleteProfile && pathname === PATHS.common.signin) {
		return (
			<Suspense
				fallback={
					<Backdrop open={true}>
						<CircularProgress />
					</Backdrop>
				}
			>
				<Component {...props} />
			</Suspense>
		)
	}

	// debugger

	// If the `requiredCompleteProfile` is true, redirect to the sign-in page
	// But not effect to the sign-up page because it has a different flow
	if (authStore.requiredCompleteProfile && pathname !== PATHS.common.signup) {
		return <Redirect to={PATHS.common.signin} />
	}

	if (pathname.includes(PATHS.auth.profile_completion)) {
		return <Component {...props} />
	}

	if (authStore.id && pathname === PATHS.common.reset) {
		return <Redirect to={{ pathname: PATHS.common.change_password }} />
	}

	if (pathname === PATHS.common.verify_credential) {
		return <CareVerifyCredentialFeature {...props} />
	}

	// !! This is a legacy code base
	// if (!socialAuthenticationId && pathname === `${PATHS.common.signup}/social`) {
	// 	return <Redirect to={{ pathname: PATHS.common.home }} />
	// }

	// if (authStore.authorization && authStore.phoneVerifyAt !== null && !commonSignInStore.changePasswordRequired && props.match.path === PATHS.common.signin) {
	// 	return (
	// 		<Redirect
	// 			to={{
	// 				pathname: PATHS.common.home || props?.location?.state?.from?.pathname,
	// 				state: { from: routerStore.from },
	// 			}}
	// 		/>
	// 	)
	// }

	if (auth) {
		if (!authStore.authorization) {
			return (
				<Redirect
					to={{
						pathname: PATHS.common.signin,
						state: { from: routerStore.from },
					}}
				/>
			)
		}

		if (feature && !authStore.features?.includes(feature)) {
			return <Error403 />
		}

		if (pathname === PATHS.care.profile) {
			if (!authStore.activated) {
				return <Redirect to={{ pathname: PATHS.care.activation }} />
			}
		}
	}

	if (authStore.id && pathsToRedirect.includes(props.match.path)) {
		return <Redirect to={{ pathname: PATHS.common.home, state: {} }} />
	}

	return (
		<Suspense
			fallback={
				<Backdrop open={true}>
					<CircularProgress />
				</Backdrop>
			}
		>
			<Component {...props} />
		</Suspense>
	)
})

export const Route = ({ auth, feature, component, transition, ...props }) => (
	<BaseRoute {...props} render={(rest) => <RouteComponent {...rest} component={component} auth={auth} feature={feature} transition={transition} />} />
)

Route.defaultProps = {
	transition: Zoom,
}
